<template>
  <div style="max-width: 100%">
    <br />
    <div
      class="list_square_titulo_valores_vacio q-pa-md"
      id="Div9"
      runat="server"
    >
      <q-btn
        title="Crear presupuesto"
        @click="nuevo_presupuesto"
        class="buttonoscuro"
        >Nuevo presupuesto</q-btn
      >
    </div>

    <div class="list_square_listado_presupuesto q-pa-md">
      <br />
      <br />
      <br />
      <q-table
        dense
        :data="data"
        :columns="columns"
        row-key="name"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns()"
      >
        <template v-slot:body="props">
          <Presupuesto
            :is-director="isDirector()"
            :dataItem="props"
            v-on:delete-row="data.splice(props.row.__index, 1)"
          />
        </template>
      </q-table>
    </div>
    <Cargando :contenido_mensaje="mensaje_cargando" />
  </div>
</template>
<script type="text/javascript">
import Cargando from '@/components/shared/components/Cargando';
import Presupuesto from './TSZ_Presupuesto';
import { QTable } from 'quasar';
import '@/components/Listados/assets/css_listado_vue.css';

export default {
  data () {
    return {
      mensaje_cargando: 'Cargando presupuestos',
      isLoading: false,
      data: [],
      pagination: {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 10
      },
      columns: [
        {
          name: 'Fecha',
          align: 'left',
          label: 'Fecha',
          field: 'Fecha'
        },
        {
          name: 'Nombre',
          align: 'left',
          label: 'Actuación',
          field: 'Nombre'
        },
        {
          name: 'Empresa',
          align: 'left',
          label: 'Empresa',
          field: 'Empresa'
        },
        {
          name: 'Provincia',
          align: 'left',
          label: 'Provincia',
          field: 'Provincia'
        },
        {
          name: 'Municipio',
          align: 'left',
          label: 'Municipio',
          field: 'Municipio'
        },
        {
          name: 'Estado',
          align: 'left',
          label: 'Estado',
          field: 'Estado'
        },
        {
          name: 'Servicio',
          align: 'left',
          label: 'Tipo',
          field: 'Servicio'
        },
        {
          name: 'Tecnologia',
          align: 'left',
          label: 'Tecnología',
          field: 'Tecnologia'
        },
        {
          name: 'CosteTcz',
          align: 'left',
          label: 'Coste TCZ',
          field: 'CosteTcz'
        },
        {
          name: 'CosteTsz',
          align: 'left',
          label: 'Coste TSZ',
          field: 'CosteTsz'
        },
        {
          name: 'BeneficioCoste',
          align: 'left',
          label: 'Coste',
          field: 'BeneficioCoste'
        },
        {
          name: 'BeneficioTiempo',
          align: 'left',
          label: 'Tiempo',
          field: 'BeneficioTiempo'
        },
        {
          name: 'ImporteOfertado',
          align: 'left',
          label: 'Ofertado',
          field: 'ImporteOfertado'
        },
        {
          name: 'AceptaGdpr',
          align: 'left',
          label: 'GDPR',
          field: 'AceptaGdpr'
        },
        {
          name: 'AvisosComerciales',
          align: 'left',
          label: 'Avisos Comerciales',
          field: 'AvisoComercial'
        }
      ]
    };
  },
  methods: {
    isDirector () {
      let internalData = this.data;
      let precioOfertado = false;

      internalData.forEach(function (element) {
        if (element.PrecioOfertado != null) {
          precioOfertado = true;
        }
      });

      return precioOfertado;
    },
    isAdmin () {
      if (this.$store.getters['TSZ/rolAplicacion'] == 2) {
        return true;
      }

      return false;
    },
    nuevo_presupuesto () {
      this.$router.push({
        name: 'Crear',
        path: '/Crear',
        component: () =>
          import('@/components/Presupuestos/views/TSZ_Presupuestos.vue')
      });
    },
    cargar_datos_listado () {
      this.isLoading = true;
      this.$store.commit('TSZ/setOffline', true);

      let request = {
        controller: '/Presupuestos/Listado',
        filter: {},
        data: {
          email: this.$store.getters['TSZ/userMail']
        }
      };

      this.$store
        .dispatch('TSZ/getDatosTSZ_Listado_Comparativa', request)
        .then((response) => {
          this.data = response.data.Data;
          this.$store.commit('TSZ/setOffline', false);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log('error_API_LISTADOS: ' + err);
          this.$store.commit('TSZ/setOffline', false);
          this.isLoading = false;
        });
    },
    visibleColumns () {
      let arrayColumn = [
        'Fecha',
        'Nombre',
        'Empresa',
        'Provincia',
        'Municipio',
        'Estado',
        'Servicio',
        'Tecnologia',
        'CosteTcz',
        'CosteTsz',
        'BeneficioCoste',
        'BeneficioTiempo',
        'AceptaGdpr',
        'AvisosComerciales'
      ];

      if (this.isAdmin() || this.isDirector()) {
        arrayColumn.push('ImporteOfertado');
      }

      return arrayColumn;
    }
  },
  mounted () {
    this.cargar_datos_listado();
  },

  components: {
    Cargando,
    Presupuesto,
    QTable
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
  }
}

.buttonclaro {
  border: 1px solid #002f6c;
  color: #002f6c;
  font-weight: bold;
  line-height: 1.14;
  letter-spacing: 1.25px;
  font-size: 14px;
  &:hover {
    background-color: $azuloscuro !important;
    color: #fff;
  }
}

.containerTable {
  margin-top: 10px;
}

.q-table__container {
  border: 1px solid rgba(10, 3, 71, 0.2);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
</style>
